import React from 'react';
import { IntlProvider } from 'react-intl';
import { useSettings } from './contexts/SettingsContextUtils';
import { NotificationContainer } from './components/common/react-notifications';
import UploadProgress from './components/common/UploadProgress';
import UserContextProvider from './contexts/user/UserContextProvider';
import { getDirection } from './helpers/Utils';
import { getLanguageTranslations } from 'lang/availableLanguages';
import AppRouter from './AppRouter';
import * as Sentry from "@sentry/react";
import { transformMessages } from './helpers/utils-typescript';
import 'yet-another-react-lightbox/styles.css';

const App: React.FC = () => {
  const { locale } = useSettings();

  React.useEffect(() => {
    const direction = getDirection();
    if (direction.isRtl) {
      document.body.classList.add('rtl');
      document.body.classList.remove('ltr');
    } else {
      document.body.classList.add('ltr');
      document.body.classList.remove('rtl');
    }
  }, []);

  const currentLanguageTranslations = getLanguageTranslations(locale);
  return (
    <UserContextProvider>
      <IntlProvider
        locale={locale}
        defaultLocale="en"
        messages={transformMessages(currentLanguageTranslations)}
        onError={(err) => {
          console.warn('IntlProvider error:', err);
        }}
      >
        <NotificationContainer />
        <UploadProgress />
        <AppRouter />
      </IntlProvider>
    </UserContextProvider>
  );
}

const AppWithProfiler = Sentry.withProfiler(App);

export default AppWithProfiler;
